import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons"
import PropTypes from "prop-types"

const BasicSortHeader = ({ column, label }) => {
  let currSort = column.getIsSorted()
  // future: if sorting on not full page size, small dialog that asks, would you like to switch to all results? (yes, setPageSize 1)

  return (
    <button
      className="text-left text-xs font-semibold uppercase tracking-wide text-gray-500 flex items-center"
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    >
      {label}
      {currSort === "asc" ? (
        <KeyboardArrowDown className="ml-2 h-4 w-4" />
      ) : currSort === "desc" ? (
        <KeyboardArrowUp className="ml-2 h-4 w-4" />
      ) : (
        <p className="ml-2 text-lg">-</p>
      )}
    </button>
  )
}

export default BasicSortHeader

BasicSortHeader.propTypes = {
  column: PropTypes.object,
  label: PropTypes.string,
}
